import EstateFilterForm from '@/js/components/forms/estateFilterForm';
import { Tooltip } from 'bootstrap';
import GoogleAdvertisement from '@/js/components/googleAdvertisments/advertisement';
import AdvertisingSizes from '@/js/components/googleAdvertisments/sizes';

/* eslint-enable */

class EstateOverview {
  constructor() {
    this.dom = {
      filterForm: document.getElementById('filter-form'),
      estateList: document.getElementById('estates-overview-list'),
      sortSelect: document.getElementById('sort'),
      googleAdvertisementLandscape: document.getElementById('banner-top'),
    };

    this.components = {
      filterForm: undefined,
      googleAdvertisementLandscape: null,
    };

    this.data = {
      sizesLandscape: new AdvertisingSizes().advertisingSizes.sizesLandscape,
      sizeLandscapeMappingRules: new AdvertisingSizes().advertisingSizes.sizeLandscapeMappingRules,
    };
  }

  mount() {
    if (this.dom.googleAdvertisementLandscape) {
      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(() => {
        // Call other functions on the SDK
        this.initGoogleAdvertisements();
      });
    }

    if (this.dom.filterForm) {
      this.components.filterForm = new EstateFilterForm(this.dom.filterForm);

      if (this.dom.sortSelect) {
        this.dom.sortSelect.addEventListener('change', this.onSortSelectChange.bind(this));
      }
      if (this.dom.estateList) {
        this.dom.estateList.addEventListener('update', () => {
          const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
          tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
        });
      }
    }

    // When the URL contains a # with the property ID we scroll to this property when it exists
    if (window.location.hash) {
      const cleanHash = window.location.hash.substring(1);
      const node = document.querySelector(`[data-id="${cleanHash}"]`);
      if (node) {
        node.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  onSortSelectChange() {
    this.components.filterForm.submit(this.dom.sortSelect);
  }

  initGoogleAdvertisements() {
    this.components.googleAdvertisementLandscape = new GoogleAdvertisement({
      container: this.dom.googleAdvertisementLandscape,
      adUnitPath: this.dom.googleAdvertisementLandscape.dataset.adUnitPath,
      setTechnicalTarget: this.dom.googleAdvertisementLandscape.dataset.setTechnicalTarget !== undefined,
      sizes: this.data.sizesLandscape,
      sizeMappingRules: this.data.sizeLandscapeMappingRules,
      scrollVisibility: this.dom.googleAdvertisementLandscape.dataset.scrollVisibility ? this.dom.googleAdvertisementLandscape.dataset.scrollVisibility : 0,
    });

    GoogleAdvertisement.initializeGpt();

    window.googletag.cmd.push(() => {
      window.googletag.display(this.dom.googleAdvertisementLandscape.id);
    });
  }
}

if (document.getElementById('page-estates-overview')) {
  new EstateOverview().mount();
}
